import type { Tile } from '../wordle.machine';

export function createEmptyGrid(
  rows: number,
  cols: number
): Tile[][] {
  return Array.from({ length: rows }, () =>
    Array.from({ length: cols }, (): Tile => ({
      letter: null,
      state: 'default',
      locked: false,
    }))
  );
}

export function findNextEditableCol(
  row: Tile[],
  start: number
): number {
  for (let i = start; i < row.length; i++) {
    const cell = row[i];
    if (!cell) continue;

    if (!cell.locked && cell.letter === null) {
      return i;
    }
  }
  return row.length;
}

export function findPrevEditableCol(
  row: Tile[],
  start: number
): number {
  for (let i = start; i >= 0; i--) {
    const cell = row[i];
    if (!cell) continue;

    if (!cell.locked) {
      return i;
    }
  }
  return -1;
}
